module.exports = __webpack_public_path__ + "img/3-24.afb4b68c.jpg";